import { Action } from 'redux';

import { getKeyForExplorableItem } from '../../../ts/models/ContentType';
import { IExplorableItemTypeInfo } from '../../../ts/models/resourceInfoParts';
import { ItemsSet, makeItemsSet } from '../../ItemsSet';
import {
  AddToContentSelection,
  DeselectAll,
  RemoveFromContentSelection,
  SelectAll,
  SelectionStart,
  SelectionStop,
} from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface AddToContentSelectionAction extends Action {
  itemsSet: ItemsSet<IExplorableItemTypeInfo>;
}

export function addToContentSelection(...items: IExplorableItemTypeInfo[]): AddToContentSelectionAction {
  return {
    type: AddToContentSelection,
    itemsSet: makeItemsSet(getKeyForExplorableItem, ...items)
  };
}

export const isAddToContentSelectionAction = isActionFactory<AddToContentSelectionAction>(AddToContentSelection);


export interface RemoveFromContentSelectionAction extends Action {
  itemsSet: ItemsSet<IExplorableItemTypeInfo>;
}

export function removeFromContentSelection(...items: IExplorableItemTypeInfo[]): RemoveFromContentSelectionAction {
  return {
    type: RemoveFromContentSelection,
    itemsSet: makeItemsSet(getKeyForExplorableItem, ...items)
  };
}

export const isRemoveFromContentSelectionAction = isActionFactory<RemoveFromContentSelectionAction>(RemoveFromContentSelection);

export interface DeselectAllAction extends Action { }

export function deselectAll(): DeselectAllAction {
  return {
    type: DeselectAll
  };
}

export const isDeselectAllAction = isActionFactory<DeselectAllAction>(DeselectAll);

export interface SelectAllAction extends Action {}

export function selectAll(): SelectAllAction {
  return {
    type: SelectAll
  };
}

export interface SelectionStartAction extends Action { }

export function startSelection(): SelectionStartAction {
  return {
    type: SelectionStart
  };
}

export const isSelectionStartAction = isActionFactory<SelectionStartAction>(SelectionStart);

export interface SelectionStopAction extends Action { }

export function stopSelection(): SelectionStopAction {
  return {
    type: SelectionStop
  };
}

export const isSelectionStopAction = isActionFactory<SelectionStopAction>(SelectionStop);
